export default () => {
  const obj = JSON.parse(localStorage.getItem("authUser"));

  if (obj && obj.token) {
    return { Authorization: "Bearer " + obj.token };
  } else {
    return {};
  }
};
